import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const MobileMenu = (props) => {
  const location = useLocation();
  const [url, setUrl] = useState(null);

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  return (
    <div className="absolute flex flex-col justify-center items-center h-screen w-screen bg-black text-white inset-0">
      <ul className="block flex flex-col h-2/5 items-center justify-between">
        <li onClick={() => props.closeMobileMenu()}>
          <Link
            to="/"
            className={
              "hover:text-white text-gray-400 font-ailerons text-4xl" +
              (url === "/" ? " active" : "")
            }
          >
            Home
          </Link>
        </li>
        <li onClick={() => props.closeMobileMenu()}>
          <Link
            to="/about"
            className={
              "hover:text-white text-gray-400 font-ailerons text-4xl" +
              (url === "/about" ? " active" : "")
            }
          >
            About
          </Link>
        </li>
        <li onClick={() => props.closeMobileMenu()}>
          <Link
            to="/portfolio"
            className={
              "hover:text-white text-gray-400 font-ailerons text-4xl" +
              (url === "/portfolio" ? " active" : "")
            }
          >
            Portfolio
          </Link>
        </li>
        <li onClick={() => props.closeMobileMenu()}>
          <a
            href="mailto:princekelvx@gmail.com"
            className="hover:text-white text-gray-400 font-ailerons text-4xl"
          >
            Contact
          </a>
        </li>
      </ul>
    </div>
  );
};

export default MobileMenu;
